// extracted by mini-css-extract-plugin
export default {"card":"styles_card__NubT7","image":"styles_image__9V8vN"};